import MeasurementsTemplate from './measurements.html';

export default angular
  .module('main.devices.edit.tabs.measurements', [])

  .directive('editDeviceMeasurementsTab', () => {
    return {
      restrict: 'E',
      template: MeasurementsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        angular.extend($scope, {});

        init();

        function init() {
          $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceLocationResource.init(),
          ]);
        }
      }
    };
  })
  .name;
